import React, { useContext } from 'react';
import styled from '@emotion/styled';
import type { WCmsHomepageSectionView } from '@zola/svc-web-api-ts-client';
import { ThemeContext } from '../../../../context';

const Story = ({
  title,
  subtitle,
  description,
}: Pick<WCmsHomepageSectionView, 'title' | 'subtitle' | 'description'>): JSX.Element => {
  const {
    components: { H3, P },
  } = useContext(ThemeContext);

  const Container = styled.div`
    display: flex;
    flex-direction: column;
    // TODO: CENTERING
    text-align: center;
  `;

  const Subtitle = styled(P)`
    margin-top: 12px;
    margin-bottom: 24px;
  `;

  return (
    <Container>
      <H3>{title}</H3>
      <Subtitle>{subtitle}</Subtitle>
      <P>{description}</P>
    </Container>
  );
};

export default Story;
